import { Routes, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { LandingComponent } from './landing/landing.component';
import { SessionComponent } from './session/session.component';
import { HomeComponent } from './home/home.component';
import { GalleryComponent } from './gallery/gallery.component';
import { authGuard, redirectLoggedInToHome } from './auth/auth.guard';
import { TermsOfServiceComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { RefundComponent } from './refund/refund.component';
import { RefundStatusComponent } from './refund-status/refund-status.component';

export const routes: Routes = [
    { path: 'login', component: LoginComponent, canActivate: [redirectLoggedInToHome] },
    { path: 'terms', component: TermsOfServiceComponent },
    { path: 'privacy', component: PrivacyComponent },
    {
        path: 'home', component: HomeComponent, canActivate: [authGuard], children: [
            { path: 'gallery', component: GalleryComponent },
            { path: 'session/:sessionId', component: LandingComponent },
            { path: 'refund', component: RefundComponent },
            { path: 'refund-status', component: RefundStatusComponent },
            { path: 'refund-status/:requestId', component: RefundStatusComponent },
            { path: '', redirectTo: 'gallery', pathMatch: 'full' }
        ]
    },
    {
        path: 'refund', redirectTo: (redirectData) => {
            const router = inject(Router);
            return router.createUrlTree(['/home/refund'], { queryParams: redirectData.queryParams });
        }
    },
    {
        path: 'refund-status', redirectTo: (redirectData) => {
            const router = inject(Router);
            return router.createUrlTree(['/home/refund-status'], { queryParams: redirectData.queryParams });
        }
    },
    {
        path: 'refund-status/:requestId', redirectTo: (redirectData) => {
            const router = inject(Router);
            return router.createUrlTree(['/home/refund-status', redirectData.params['requestId']], { queryParams: redirectData.queryParams });
        }
    },
    {
        path: 'session/:sessionId', redirectTo: (redirectData) => {
            const router = inject(Router);
            return router.createUrlTree(['/home/session', redirectData.params['sessionId']], { queryParams: redirectData.queryParams });
        }
    },
    { path: '', redirectTo: 'login', pathMatch: 'full' }
];

